import {
  AnchorIcon,
  CoffeeIcon,
  CrownIcon,
  FlameIcon,
  HeartIcon,
  LeafIcon,
  MountainIcon,
  SmileIcon,
  SparklesIcon,
  StarIcon,
  SunIcon,
  ZapIcon,
} from "lucide-react";

export const cliparts = [
  { id: "heart", name: "Cœur", icon: HeartIcon },
  { id: "star", name: "Étoile", icon: StarIcon },
  { id: "leaf", name: "Feuille", icon: LeafIcon },
  { id: "sparkles", name: "Étincelles", icon: SparklesIcon },
  { id: "zap", name: "Éclair", icon: ZapIcon },
  { id: "smile", name: "Sourire", icon: SmileIcon },
  { id: "sun", name: "Soleil", icon: SunIcon },
  { id: "flame", name: "Flamme", icon: FlameIcon },
  { id: "crown", name: "Couronne", icon: CrownIcon },
  { id: "mountain", name: "Montagne", icon: MountainIcon },
  { id: "anchor", name: "Ancre", icon: AnchorIcon },
  { id: "coffee", name: "Café", icon: CoffeeIcon },
];

export const fonts = [
  { id: "helvetica", name: "Bâton", family: '"Helvetica Neue", Helvetica, Arial, sans-serif', weight: 700 },
  { id: "archivo", name: "Impact", family: '"Archivo Black", sans-serif', weight: 400 },
  { id: "playfair", name: "Élégant", family: '"Playfair Display", serif', weight: 700 },
  { id: "caveat", name: "Manuscrit", family: '"Caveat", cursive', weight: 700 },
  { id: "mono", name: "Machine", family: '"IBM Plex Mono", monospace', weight: 600 },
];

export const inkColors = [
  { id: "noir", name: "Noir", hex: "#0A0A0A" },
  { id: "blanc", name: "Blanc", hex: "#FFFFFF" },
  { id: "cerise", name: "Rouge cerise", hex: "#C8102E" },
  { id: "menthe", name: "Menthe", hex: "#2EF08F" },
  { id: "rose", name: "Rose", hex: "#FFB3C8" },
  { id: "marine", name: "Marine", hex: "#1F2A44" },
  { id: "or", name: "Or", hex: "#C9A227" },
  { id: "gris", name: "Gris", hex: "#8A8A8A" },
];

export const sampleLogo = {
  name: "logo-exemple.svg",
  src:
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 260 120"><path d="M60 100 L22 62 A21 21 0 0 1 60 30 A21 21 0 0 1 98 62 Z" fill="#C8102E"/><text x="114" y="58" font-family="Helvetica, Arial, sans-serif" font-weight="700" font-size="32" fill="#0A0A0A">VOTRE</text><text x="114" y="94" font-family="Helvetica, Arial, sans-serif" font-weight="700" font-size="32" fill="#0A0A0A">LOGO</text></svg>'
    ),
};
